/**
 * Enumerates error event types
 */
export enum ErrorEventType {
  /**
   * `BootstrapError` is published when an error occurs Bootstrap execution.
   * See `BootstrapErrorType`
   */
  BootstrapError = 'BootstrapError',
  /**
   * `OnboardingDirectorUnavailable` is published when Onboarding Director API
   * returns and error.
   */
  OnboardingDirectorUnavailable = 'OnboardingDirectorUnavailable',

  /**
   * `OnboardingCenterUnavailable` is published when Onboarding Center
   * returns and error.
   */
  OnboardingCenterUnavailable = 'OnboardingCenterUnavailable'
}

/**
 * Enumerates the `BootstrapError` types
 */
export enum BootstrapErrorType {
  /**
   * `startupError` type occurs when the Bootstrap Webapp is loading and creating resources to get ready
   */
  startupError = 'startupError',
  /**
   * `deviceHttpProxyCallError` type occurs when a call to `DeviceHttpProxyPlugin`
   * return an error
   */
  deviceHttpProxyCallError = 'deviceHttpProxyCallError',
  /**
   * `createSessionError` type occurs when the session creation on Onboarding Director returns an error
   */
  createSessionError = 'createSessionError',
  /**
   * `NetworkError` type occurs when a network is not available
   */
  networkError = 'networkError',
  /**
   * `unknownError` type occurs on unknown error
   */
  unknownError = 'unknownError'
}

/**
 * Represents an error that occurs during the execution
 */
export interface ErrorEvent {
  appSessionId?: string
  errorType?: string
  reason: string
}

/**
 * Enumerates the events that occurs during the execution
 */
export enum BootstrapEventType {
  BootstrapWebAppReady = 'BootstrapWebAppReady',
  NoPlan = 'NoPlan'
}

/**
 * Possible error codes returned by bootstrap
 */
export enum ErrorCode {
  // Service Routing returned error after launching Onboarding Center
  EBS00P0001 = 'EBS00P0001',
  // The Onboarding Center service is not available on Service Routing services list
  EBS00P0002 = 'EBS00P0002',
  // Service Routing returned error while trying to launch Onboarding Center
  EBS00P0003 = 'EBS00P0003',
  // No valid DeviceResource was returned from the printer
  EBS00P0004 = 'EBS00P0004',
  // Launch parameters is missing required parameter "odId" from query/launchOptions
  EBS00P0005 = 'EBS00P0005',
  // HTTP Proxy returned an error
  EBS00P0006 = 'EBS00P0006',
  // All resources failed with dataValveError
  EBS00P0007 = 'EBS00P0007',
  // The request to create the onboarding session with Onboarding Director did timeout
  EBS00P0008 = 'EBS00P0008',
  // The request to create the onboarding session with Onboarding Director returned a network error
  EBS00P0009 = 'EBS00P0009',
  // All resources failed with deviceOffline
  EBS00P0010 = 'EBS00P0010',
  // All resources failed with requestTimedOut
  EBS00P0011 = 'EBS00P0011',
  // All resources failed with invalidSession
  EBS00P0012 = 'EBS00P0012',
  // All resources failed with unknownError
  EBS00P0013 = 'EBS00P0013',
  // All resources failed with bodyOrDataInvalid
  EBS00P0014 = 'EBS00P0014',
  // DRP execution threw an error
  EBS00P0015 = 'EBS00P0015',
  // The request to create the onboarding session with Onboarding Director returned an unexpected status code, where XXX is status code
  EBS00P1XXX = 'EBS00P1XXX'
}
